// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"q7-z"};